import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import GjennomkjoringForbudter from "../../RouteDescription/GjennomkjoringForbudter";

export default function GjennomkjoringForbudt(props: IRoadFeatureListItemProps) {
    const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

   return(
      <>
        {props.roadFeatureResponse && 
        props.roadFeatureResponse.gjennomkjoringForbudt && 
        props.roadFeatureResponse.gjennomkjoringForbudt.length !== 0 &&
          <>
          <ListItemButton
            onClick={onClick}>
              <ListItemText primary={`Gjennomkjøring forbudt (${props.roadFeatureResponse?.gjennomkjoringForbudt.length})`}/> 
              {open ? <ExpandLess /> : <ExpandMore />} 
            </ListItemButton>
            <Collapse
            in={open}
            timeout="auto" 
            unmountOnExit
            >
              <GjennomkjoringForbudter roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
            </Collapse>
            <Divider />
          </>
        }
      </>
    )
}